<template>
  <main>
    <section class="d-flex flex-row flex-wrap justify-content-between row-1">
      <div class="d-flex flex-row">
        <h1>REMBOURSEMENTS</h1>
        <div class="align-self-center">100</div>
      </div>
      <div class="align-self-center">
        <font-awesome-icon size="2x" :icon="['fas', 'people-arrows']"></font-awesome-icon>
      </div>
    </section>
    <section class="d-flex flex-row flex-wrap justify-content-between row-2">
      <div class="w-40 input-group flex-nowrap column-left">
        <input type="text" class="form-control" placeholder="Rechercher..." aria-label="Username" aria-describedby="addon-wrapping">
        <div class="input-group-prepend">
            <span class="input-group-text" id="addon-wrapping">
              <font-awesome-icon :icon="['fas', 'search']"></font-awesome-icon>
            </span>
        </div>
      </div>
      <div class="column-right">
        <button class="btn">
          <font-awesome-icon :icon="['fas', 'sort']"></font-awesome-icon>
          <span>A-Z</span>
        </button>
        <button class="btn">
          <font-awesome-icon :icon="['fas', 'sort']"></font-awesome-icon>
          <span>Date</span>
        </button>
      </div>
    </section>
    <hr>
    <section class="row-3">
      <ul class="list-group">
        <li class="list-group-item active d-flex flex-row justify-content-between">
          <div>NOMS</div>
          <div>OPTIONS</div>
        </li>
        <li class="d-flex flex-row flex-wrap flex-md-nowrap justify-content-between list-group-item">
          <div class="w-100 w-md-50 text-center text-md-left">RIDI NSIMBA LUAMBA</div>
          <div class="mt-2 mt-md-0 w-100 w-md-30 d-flex flex-row justify-content-around">
            <div class="div-icon-read" v-b-toggle.collapse-1 @click="selectedComponent = 'AppRead'">
              <font-awesome-icon :icon="['fas', 'eye']"></font-awesome-icon>
            </div>
          </div>
        </li>
        <b-collapse id="collapse-1" class="list-group-item">
          <component :is="selectedComponent"></component>
        </b-collapse>
      </ul>
    </section>
    <section class="d-flex flex-row justify-content-center row-4">
      <nav aria-label="Page navigation">
        <ul class="pagination">
          <li class="page-item"><a class="page-link" href="#">Précédent</a></li>
          <li class="page-item"><a class="page-link" href="#">1</a></li>
          <li class="page-item"><a class="page-link" href="#">2</a></li>
          <li class="page-item"><a class="page-link" href="#">3</a></li>
          <li class="page-item"><a class="page-link" href="#">Suivant</a></li>
        </ul>
      </nav>
    </section>
  </main>
</template>

<script>
import Read from "./components/Read";

export default {
  name: "Remboursements",
  data(){
    return{
      selectedComponent: 'AppRead'
    }
  },
  components: {
    AppRead: Read
  }
}
</script>

<style lang="scss" scoped>
main{
  & > section{
    margin-top: 1rem;
  }
  & > section.row-1{
    border-radius: 1rem;
    padding: .2rem .8rem;
    background-color: var(--color-chestnut-rose, rgba(212, 106, 106, 1));
    & > div:nth-child(1){
      & > h1{
        font-size: larger;
        color: var(--color-white, rgba(255, 255, 255, 1));
      }
      & > div{
        font-weight: bold;
        margin-left: 1rem;
        background-color: var(--color-white, rgba(255, 255, 255, 1));
        color: var(--color-black, rgba(0, 0, 0, 1));
        padding: .2rem;
        border-radius: .5rem;
      }
    }
    & > div:nth-child(2){
      color: var(--color-white, rgba(255, 255, 255, 1));
    }
  }
  & > section.row-2{
    & > div.column-left{
      & > input{
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }
      & > div{
        & > span{
          background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
          color: var(--color-white, rgba(255, 255, 255, 1));
          border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        }
      }
    }
    & > div.column-right{
      & > button{
        border: 1px solid var(--color-curious-blue, rgba(34, 134, 195, 1));
      }
      & > button:hover{
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
      }
    }
  }
  & > section.row-3{
    & > ul{
      & > li:nth-child(1){
        & > div{
          font-weight: bold;
          font-style: italic;
        }
      }
      & > li:nth-child(n+2){
        & > div:nth-child(1){}
        & > div:nth-child(2){
          & > div, & > div:active,  & > div:hover{
            padding: .05rem .4rem;
            border: 1px solid var(--color-maya-blue, rgba(100, 181, 246, 1));
            border-radius: .2rem;
          }
          & > .div-icon-create{
            color: var(--color-apropos-section-1, rgba(23, 162, 184, 1))
          }
          & > .div-icon-read{
            color: var(--color-apropos-section-2, rgba(212, 106, 106, 1));
          }
          & > .div-icon-update{
            color: var(--color-apropos-section-3, rgba(40, 167, 69, 1));
          }
          & > .div-icon-delete{
            color: var(--color-apropos-section-4, rgba(232, 62, 140, 1));
          }
          & > .div-icon-message{
            color: var(--color-apropos-section-5, rgb(32, 201, 151));
          }
          & > .div-icon-create:hover{
            color: var(--color-white, rgba(255, 255, 255, 1));
            background-color: var(--color-apropos-section-1, rgba(23, 162, 184, 1));
          }
          & > .div-icon-read:hover{
            color: var(--color-white, rgba(255, 255, 255, 1));
            background-color: var(--color-apropos-section-2, rgba(212, 106, 106, 1));
          }
          & > .div-icon-update:hover{
            color: var(--color-white, rgba(255, 255, 255, 1));
            background-color: var(--color-apropos-section-3, rgba(40, 167, 69, 1));
          }
          & > .div-icon-delete:hover{
            color: var(--color-white, rgba(255, 255, 255, 1));
            background-color: var(--color-apropos-section-4, rgba(232, 62, 140, 1));
          }
          & > .div-icon-message:hover{
            color: var(--color-white, rgba(255, 255, 255, 1));
            background-color: var(--color-apropos-section-5, rgb(32, 201, 151));
          }
        }
      }
    }
  }
  & > section.row-4{
    & > nav{
      & > ul.pagination{
        & > li.page-item{
          & > a.page-link{
            color: var(--color-black, rgba(0, 0, 0, 1));
            border-color: var(--color-black, rgba(0, 0, 0, 1));
          }
          & > a.page-link:hover{
            color: var(--color-white, rgba(255, 255, 255, 1));
            background-color: var(--color-black, rgba(0, 0, 0, 1));
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/remboursements/Remboursements.vue